var map = {
	"./1right.png": "BEvR",
	"./2right.png": "QO4n",
	"./3right.png": "3fLB",
	"./4right.png": "ZkNf",
	"./5right.png": "Lpb5",
	"./6right.png": "gUIm",
	"./7right.png": "Pnfo"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9ZTV";